import api, { USE_MOCK } from './apiClient';
import mockApi from '../mock/backend';

export const folderService = {
  get(folderId) {
    if (USE_MOCK) return mockApi.getFolder(folderId);
    return api.get(folderId ? `/folders/${folderId}` : '/folders/root');
  },

  tree() {
    if (USE_MOCK) return mockApi.listFolderTree();
    return api.get('/folders/tree');
  },

  create(payload) {
    if (USE_MOCK) return mockApi.createFolder(payload);
    return api.post('/folders', payload);
  },

  rename(id, name) {
    if (USE_MOCK) return mockApi.renameFolder(id, name);
    return api.patch(`/folders/${id}`, { name });
  },

  remove(id) {
    if (USE_MOCK) return mockApi.deleteFolder(id);
    return api.delete(`/folders/${id}`);
  },

  move(id, targetParentId) {
    if (USE_MOCK) return mockApi.moveFolder(id, targetParentId);
    return api.post(`/folders/${id}/move`, { targetParentId });
  },
};

export default folderService;
